<app-file-input #fileInput
                *ngIf="!readonly"
                [acceptedTypes]="'image/*'"
                [required]="true"
                [hasError]="showValidations"
                (onFileUpload)="selectFiles($event)"
                (onFilesSelected)="selectFiles($event)"
                (onFileRemoved)="selectFiles($event)">
</app-file-input>
<app-photo-carousel [photos]="carouselPhotos"
                    [numVisibleItems]="visiblePhotos"
                    [canDelete]="!readonly"
                    (deletePhoto)="selectCarouselFiles($event)">
</app-photo-carousel>
